import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Mason Patriots</p>
        <h1>Welcome to the Mason Patriots Sports Hub!</h1>
        <p className="lede">
          Stay connected with your favorite teams! Get the latest schedules, news, and updates for all Mason Patriots sports teams right here.
        </p>
        <div className="cta-row">
          <a href="/schedules" target="_self">
            View Schedules
          </a>
          <a href="/news" target="_self" className="secondary">
            Read Latest News
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Upcoming Events</h2>
          <p>
            Never miss a game! Check out our comprehensive schedule to stay up-to-date on all upcoming matches and events.
          </p>
        </article>
        <article>
          <h2>Team News</h2>
          <p>
            Get the latest updates and insights from the Mason Patriots teams. From player highlights to game recaps, we’ve got you covered.
          </p>
        </article>
        <article>
          <h2>Join the Community</h2>
          <p>
            Be part of the action! Follow us on social media and join our mailing list for exclusive updates and fan engagement opportunities.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;